import { Stat } from "./types";
import { capitalizeAssociatedPress } from "../../helpers/string/capitalize";
import { formatNumber } from "../../helpers";
import { TextPreloader } from "../../components/DataDisplay/TextPreloader";
import { StateToBadge } from "../../ui/layout/molecules/Badge/StateToBadge";

type StatsProps = {
  className?: string;
  loading: boolean;
  error: boolean;
  stats: Stat[];
};

export default function Stats({
  stats,
  loading,
  error,
  className,
}: StatsProps) {
  return (
    <div className={className ?? ""}>
      <dl className="mt-4 grid grid-cols-1 gap-5 lg:grid-cols-3">
        {stats?.map(
          (item: Stat, index) =>
            !!item.primaryStat && (
              <div
                key={index}
                className="overflow-hidden rounded-lg bg-stone-50 px-4 py-5 shadow dark:bg-stone-800 sm:p-6"
              >
                <dt className="text-primary truncate text-base font-normal">
                  {capitalizeAssociatedPress(item.name)}
                </dt>
                <dd className="mt-1 flex items-baseline md:block lg:flex">
                  <div className="flex items-baseline text-2xl font-semibold text-black dark:text-white">
                    {error ? (
                      StateToBadge("noData")
                    ) : (
                      <TextPreloader loaded={loading}>
                        {`${formatNumber(item.primaryStat)}${
                          item.addPercentage ? " %" : ""
                        }`}
                      </TextPreloader>
                    )}
                  </div>
                </dd>
              </div>
            ),
        )}
      </dl>
    </div>
  );
}
